import Api from "../Helpers/Api";

class LevelsService {
  getLevels() {
    return Api.get(`/niveis`);
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new LevelsService();